import { Attachment, IAttachment } from '@app/models/Attachment'
import { SiteSuggestionStatus } from '@app/models/enums'
import { List, Record } from 'immutable'

export interface ISiteSuggestion {
  readonly files: List<IAttachment>
  readonly clientName: string
  readonly clientId: string
  readonly contactName: string
  readonly contactCompany: string
  readonly contactEmail: string
  readonly contactPhone: string
  readonly dateCreated: number
  readonly id: string
  readonly siteAddress: string
  readonly siteCity: string
  readonly siteState: string
  readonly siteZip: string
  readonly siteSize: string
  readonly fileIds: string
  readonly status: SiteSuggestionStatus
  readonly onTheMarket: boolean
  readonly marketPrice: number
}

const SiteSuggestionRecord = Record({
  clientId: '',
  clientName: '',
  contactCompany: '',
  contactEmail: '',
  contactName: '',
  contactPhone: '',
  dateCreated: 0,
  fileIds: '',
  files: List<Attachment>(),
  id: '',
  marketPrice: 0,
  onTheMarket: false,
  siteAddress: '',
  siteCity: '',
  siteSize: '',
  siteState: '',
  siteZip: '',
  status: 'Pending',
})

export class SiteSuggestion extends SiteSuggestionRecord
  implements ISiteSuggestion {
  public static fromJS(initialState?: Partial<ISiteSuggestion>) {
    if (!initialState) {
      return new SiteSuggestion()
    }

    const { files, ...rest } = initialState

    return new SiteSuggestion({
      files: files ? List(files.map((a) => Attachment.fromJS(a))) : undefined,
      ...rest,
    })
  }

  public readonly files: List<Attachment>
  public readonly clientName: string
  public readonly clientId: string
  public readonly contactName: string
  public readonly contactCompany: string
  public readonly contactEmail: string
  public readonly contactPhone: string
  public readonly dateCreated: number
  public readonly id: string
  public readonly siteAddress: string
  public readonly siteCity: string
  public readonly siteState: string
  public readonly siteZip: string
  public readonly siteSize: string
  public readonly fileIds: string
  public readonly status: SiteSuggestionStatus
  public readonly onTheMarket: boolean
  public readonly marketPrice: number

  constructor(props?: Partial<SiteSuggestion>) {
    props ? super(props) : super()
  }
}
